import { Link } from 'react-router-dom';
import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9qr8bnnahb7382ove30';

const aboutFaqs = [
  {
    question: '韩漫大全是什么时候成立的？',
    answer: '韩漫大全成立于2020年，由一群热爱韩国漫画的年轻人共同创立。经过多年的发展，我们已经成为国内领先的韩国漫画在线阅读平台之一，为数百万韩漫爱好者提供优质的阅读服务。',
  },
  {
    question: '韩漫大全的漫画来源是哪里？',
    answer: '我们的漫画内容来自与韩国多家知名漫画平台和出版社的正版合作。所有漫画均经过正规授权，确保读者能够阅读到高清、完整、合法的漫画内容。',
  },
  {
    question: '为什么选择韩漫大全？',
    answer: '韩漫大全拥有业界领先的阅读体验——高清画质、流畅加载、智能推荐。我们每日更新最新章节，涵盖八大分类，5000+部漫画库，完全免费无需付费。无论是手机还是电脑，都能享受优质的阅读体验。',
  },
  {
    question: '韩漫大全如何保障用户隐私？',
    answer: '我们高度重视用户隐私保护，采用业界标准的加密技术保护用户数据。我们不会在未经用户同意的情况下向第三方分享个人信息，并严格遵守相关法律法规。',
  },
];

export default function AboutPage() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormSubmitted(true);
      return;
    }

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          payload.append(key, value as string);
        }
      });
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      if (response.ok && parsed?.code === 'OK') {
        setFormSubmitted(true);
        form.reset();
      } else if (serverMsg && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
        setFormError('提交失败，请稍后重试');
      } else {
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <>
      <title>关于我们 - 韩漫大全 | 品牌介绍与联系方式</title>
      <meta name="description" content="韩漫大全成立于2020年，是国内领先的韩国漫画在线阅读平台。了解韩漫大全的品牌故事、用户口碑与联系方式，享受海量正版韩漫免费阅读。" />
      <meta name="keywords" content="韩漫大全,关于韩漫大全,韩漫大全联系方式,韩漫大全品牌介绍,韩漫平台" />
      <link rel="canonical" href="https://hanmandq.com/about" />

      <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <ol className="flex items-center gap-2 text-xs text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors duration-200">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-800 font-medium">关于我们</li>
          </ol>
        </div>
      </nav>

      <section className="w-full pt-16 pb-10 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            关于韩漫大全
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            致力于为韩漫爱好者提供最优质的免费在线阅读体验
          </p>
        </div>
      </section>

      <section className="w-full py-10 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
              品牌介绍
            </h2>
            <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
              <p>
                <strong>韩漫大全</strong>成立于2020年，由一群热爱韩国漫画的年轻人共同创立。我们的使命是让每一位韩漫爱好者都能免费、便捷地阅读到自己喜爱的韩国漫画作品。
              </p>
              <p>
                经过多年的发展，韩漫大全已经成为国内领先的韩国漫画在线阅读平台之一。我们与韩国多家知名漫画平台和出版社建立了深度合作关系，确保所有漫画内容均为正版授权，让读者看得放心、读得安心。
              </p>
              <p>
                平台目前收录了超过<strong>5000部</strong>优质韩国漫画，涵盖恋爱、悬疑、奇幻、校园、动作、喜剧、剧情、恐怖等八大分类。我们每日同步更新最新章节，确保读者能在第一时间阅读到最新内容。
              </p>
              <p>
                韩漫大全完美适配手机、平板和电脑等全平台设备，无论你身在何处，都能享受流畅的漫画阅读体验。我们坚持<strong>完全免费</strong>的运营理念，没有任何付费墙或隐藏收费，让每一位韩漫爱好者都能尽情享受阅读的乐趣。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-10 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              用户口碑
            </h2>
            <p className="mt-2 text-sm text-foreground-600">来自真实用户的评价</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: item.rating }, (_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-10 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-8 border border-background-200/70">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-6">
              联系我们
            </h2>

            {formSubmitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-check-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">提交成功！</h3>
                <p className="mt-2 text-sm text-foreground-500">感谢您的留言，我们会尽快回复您。</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div>
                  <label htmlFor="name" className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                    placeholder="请输入您的留言内容（500字以内）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="anti-spam-field"
                />

                {formError && (
                  <p className="text-xs text-red-500">{formError}</p>
                )}

                <button
                  type="submit"
                  className="bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
                >
                  提交留言
                </button>
              </form>
            )}
          </div>

          <div className="mt-10 max-w-lg mx-auto grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <p className="mt-3 text-xs font-medium text-foreground-700">邮箱</p>
              <p className="mt-1 text-xs text-foreground-500">support@hanmandq.com</p>
            </div>
            <div className="text-center bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-time-line text-lg"></i>
              </div>
              <p className="mt-3 text-xs font-medium text-foreground-700">工作时间</p>
              <p className="mt-1 text-xs text-foreground-500">周一至周五 9:00-18:00</p>
            </div>
            <div className="text-center bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-chat-3-line text-lg"></i>
              </div>
              <p className="mt-3 text-xs font-medium text-foreground-700">响应时间</p>
              <p className="mt-1 text-xs text-foreground-500">24小时内回复</p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-14 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
          </div>

          <div className="flex flex-col gap-3">
            {aboutFaqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer transition-colors duration-200 hover:bg-background-200/50"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 ${
                    openFAQ === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openFAQ === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于韩漫大全",
            "description": "韩漫大全成立于2020年，是国内领先的韩国漫画在线阅读平台。",
            "url": "https://hanmandq.com/about",
            "mainEntity": {
              "@type": "Organization",
              "name": "韩漫大全",
              "foundingDate": "2020",
              "description": "韩漫大全 - 海量韩国漫画免费在线阅读平台",
              "url": "https://hanmandq.com/",
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer service",
                "email": "support@hanmandq.com",
                "availableLanguage": "Chinese"
              }
            }
          })
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://hanmandq.com/" },
              { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://hanmandq.com/about" }
            ]
          })
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": aboutFaqs.map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })
        }}
      />
    </>
  );
}